import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import FaCheck from 'react-icons/lib/fa/check';
import {
    ADD_SELECTED_CONTRACTORS,REMOVE_SELECTED_CONTRACTORS  }  from "actions/actionTypes";
import config from  '../../../config';
import {Link} from 'react-router';
import {getFieldByPathFormatter, customTableSelect,customFormatter,dateFormatter, actionsFormatter} from 'util/Utils';
class AdminContractorListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            recordIDs:[],
            perPage: config.table.numberPerPage
        };
    }

    onRowSelect(row, isSelected, e) {
         var actionName =   isSelected ? ADD_SELECTED_CONTRACTORS : REMOVE_SELECTED_CONTRACTORS;
         this.props.dispatchAction([row], actionName)
    }
    onAllRowSelect(isSelected, rows){
        var actionName =   isSelected ? ADD_SELECTED_CONTRACTORS : REMOVE_SELECTED_CONTRACTORS;
        this.props.dispatchAction(rows, actionName)
    }
    customMultiSelect(props) {
       return customTableSelect(props, {table:this.refs.table, selectedRows:this.props.adminContractors.selectedContractors});
    }


    contractorProductsLinkFormatter(cell, row, extra) {
        return (
            <Link className=" underlineText" target="_blank"
                  to={'/admin/products?ContractorID='+encodeURIComponent(row._id)}>{row['UserID'] ? row['UserID']['firstName'] : ''}</Link>
        );
    }

    editContractorLinkFormatter(cell, row, extra) {
         /* display products for the contractor*/
        return (
            <Link className=" underlineText" target="_blank"
                  to={'/admin/contractor/'+encodeURIComponent(row._id)+'/edit'}>{ row['ContractorNumber'] }</Link>
        );
    }


    render() {
        const  selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.props.onRowSelect,
            onSelectAll: this.props.onAllRowSelect,
            customComponent: this.props.customMultiSelect
          //  onSelect: this.onRowSelect.bind(this),
         //   onSelectAll: this.onAllRowSelect.bind(this),
         //   customComponent: this.customMultiSelect.bind(this)
        }

        return (
            <div className="panel panel-default">
                <div className=" databases-table">
                    <BootstrapTable ref='table'
                                    data={this.props.adminContractors.data}
                                    selectRow={ selectRowProp }
                                    remote={true}
                                    hover={true}
                                    condensed={true}
                                    striped={true}
                                    options={ {
                                        ...config.bootstrapTableOptions,
                                        onSortChange: this.props.onSortChange
                                    } } >
                        <TableHeaderColumn width="30px"   dataAlign="center"    formatExtraData={ {path: ['UserID', 'firstName']}}
                                           dataFormat={ getFieldByPathFormatter }
                                           dataField="UserID.firstName"  dataSort={true}  >First Name</TableHeaderColumn>
                        <TableHeaderColumn width="0px"  dataField="_id" isKey={true} hidden={true}
                                           autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>
                        <TableHeaderColumn width="40px"  dataAlign="center"   formatExtraData={ {path: ['UserID', 'lastName']}}
                                           dataFormat={ getFieldByPathFormatter }
                                           dataField="UserID.lastName"  dataSort={true}   columnClassName={'break-word'}   >Last Name</TableHeaderColumn>
                         <TableHeaderColumn width="60px"   formatExtraData={ {path: ['UserID', 'email']}}
                                           dataFormat={ getFieldByPathFormatter }   dataAlign="center"  columnClassName={'break-word'}  dataField="UserID.email"  dataSort={true} >Email</TableHeaderColumn>
                        <TableHeaderColumn width="40px"  dataAlign="center" dataField='Type'
                                           dataSort={true}>Type</TableHeaderColumn>
                        <TableHeaderColumn width="40px"  dataAlign="center" dataField='MarketName'
                                           dataSort={true}>Location</TableHeaderColumn>
                        <TableHeaderColumn width="30px"   dataAlign="center"      dataFormat={ customFormatter }
                                           formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                            var foundPaymentMethod =_.find(_.map(config.payoutMethodsMap, function (key, value) {
                                                return {value: value, label: key}
                                            }), {'value':   _.get(row, ['PaymentMethod'])})
                                                return _.get(foundPaymentMethod,'label','')
                                           }}}
                                           dataField="UserID.firstName"  dataSort={true}  >Payment Method</TableHeaderColumn>
                        <TableHeaderColumn width="40px"  dataAlign="center" dataField='Status'
                                           dataSort={true}>Status</TableHeaderColumn>
                        <TableHeaderColumn width="40px"  dataAlign="center"   dataField='UserID.Devices'
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                               var styles = {position:'relative', top:2}
                                               if  (_.get(row,'UserID.Devices',[]).length >0){
                                                   styles.color= 'green'
                                               }else  {
                                                   styles.color= 'red'
                                               }
                                               return <div>

                                                      <FaCheck style={styles}></FaCheck>

                                               </div>

                                           }}}
                                           dataSort={true}>Push notifications</TableHeaderColumn>
                        <TableHeaderColumn
                                            columnClassName={'actions-column'}
                                           dataAlign="center" formatExtraData={ {   menuItemsMap : {Active:[
                            {onClick: (row)=>{
                                this.props.editRecord(row)
                            }, label: 'Edit'},
                            {onClick:   (row)=>{
                            this.props.showRemoveDialog(row)
                        }, label: 'Delete'},
                        ] },currentItem: 'Active' } }
                                            dataFormat={ actionsFormatter.bind(this) } ></TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>

        );
    }
}


export default AdminContractorListTable;
